export const CONTACT_ACTIVITY_DATA_REQUEST = 'CONTACT_ACTIVITY_DATA_REQUEST'
export const CONTACT_ACTIVITY_DATA_SUCCESS = 'CONTACT_ACTIVITY_DATA_SUCCESS'
export const CONTACT_ACTIVITY_DATA_FAIL = 'CONTACT_ACTIVITY_DATA_FAIL'
export const CONTACT_ACTIVITY_DATA_RESET = 'CONTACT_ACTIVITY_DATA_RESET'

